<template>
  <div class="tjinformationDetails">
    <div class="posit">
      当前位置：
      优秀企业推介
      <span style="margin: 0 10px">></span>
      <span>企业访谈专区</span>
      <span style="margin: 0 10px">></span>
      企业访谈专区详情
    </div>
    <div class="detail">
      <div class="content_top">
        <p class="content_top_title">{{ title }}</p>
        <span>
          <img src="../../assets/image/time.png" alt style="margin: 2px 8px 0 0;" />
          <span>{{ time }}</span>
        </span>
        <span>
          <img src="../../assets/image/eye.png" alt style="margin: 4px 6px 0 25px;" />
          <span>{{ watch }}</span>
        </span>
      </div>
      <!-- <div class="content_center" v-html="content"></div> -->
      <div class="content_center" v-html="content"></div>
      <!-- <div class="content_bottom">
          <div class="left">
            <img src="../../assets/image/weixin.png" alt />
            <img src="../../assets/image/weibo.png" alt />
          </div>
          <div class="center">
            <img src="../../assets/image/zan.png" alt />
            <p class="num">{{ fabulous }}</p>
            <p>赞</p>
          </div>
      </div>-->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      content: "",
      title: "",
      time: "",
      watch: "", // 浏览
      fabulous: 0, // 点赞
    };
  },
  activated() {
    let routeDetailId = this.$route.query.detailId;
    if (routeDetailId) {
      this.inforDetail(routeDetailId);
    }
  },
  mounted() {},
  methods: {
    // 详情
    inforDetail(id) {
      this.$store.commit("SET_TJCOREINFO", false);
      sessionStorage.setItem("coreId", id);
      this.$http({
        url: "promotion/getPromotionInfo",
        method: "post",
        params: {
          id: id,
        },
      }).then(({ data }) => {
        let { code, promotion } = data;
        if (code === 0) {
          this.title = promotion.title;
          this.time = promotion.uploadDate.substring(0, 16);
          this.watch = promotion.watch;
          this.content = promotion.content.replace(
            /<img/g,
            "<img style='max-width: 100%;height: auto; crossOrigin; display: block; margin: 0 auto;' "
          );
          this.fabulous = promotion.promotion;
        }
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem("coreId");
    this.$store.commit("SET_TJCOREINFO", true);
    next();
  },
};
</script>
<style lang="scss" scoped>
.tjinformationDetails {
  .posit {
    margin: 31px 0 15px 0;
    padding-left: 25px;
    color: #999999;
    font-size: 12px;
  }
}
</style>